import { hotelResultsApi } from '@hotels/hotel-results/hotel-results.api';
import { autoApi } from '@autos/auto.api';
import { flightResultsApi } from '@flight-results/flight-results.api';
import { packagesResultApi } from '@packages/packages-result/packages-result.api';
import { activitiesApi } from '@activities/api/activities.api';

export const apiHasLoader = [
  flightResultsApi.air_search,
  flightResultsApi.air_search_by_sector,

  autoApi.auto_search,
  autoApi.auto_results,

  hotelResultsApi.hotel_search,
  hotelResultsApi.hotel_results,
  hotelResultsApi.hotel_search_byhours,

  packagesResultApi.package_search,
  packagesResultApi.package_air_results,
  packagesResultApi.package_hotel_results,

  activitiesApi.search,
];
